// src/components/Visualization/KpiCardGroup.js
import React from 'react';
import KpiCard from './KpiCard';

/**
 * KpiCardGroup - Grupo responsivo de cartões de métricas KPI
 * 
 * @param {Object} props
 * @param {Array} props.metrics - Array de configurações de métricas
 * @param {string} props.layout - Layout dos cartões ('grid' ou 'grid-compact')
 * @param {boolean} props.equalHeight - Forçar mesma altura para todos os cartões
 * @param {string} props.className - Classes adicionais para estilização
 */
const KpiCardGroup = ({
  metrics = [],
  layout = 'grid',
  equalHeight = true,
  className = ''
}) => {
  // Determinar classes de grid com base no layout
  const getGridClasses = () => {
    switch (layout) {
      case 'grid-compact':
        return 'grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4';
      case 'grid-medium':
        return 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5';
      case 'grid':
      default:
        return 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 sm:gap-6';
    }
  };

  // Se não tiver métricas, não renderizar nada
  if (!metrics.length) return null;

  return (
    <div className={`${getGridClasses()} ${className}`}>
      {metrics.map((metric, index) => (
        <KpiCard
          key={`metric-${index}`}
          title={metric.title}
          value={metric.value}
          prefix={metric.prefix}
          suffix={metric.suffix}
          change={metric.change}
          timeframe={metric.timeframe}
          trendData={metric.trendData}
          trendKey={metric.trendKey}
          color={metric.color}
          autoColor={metric.autoColor !== false}
          inverseTrend={metric.inverseTrend}
          className={`${equalHeight ? 'h-full' : ''} ${metric.className || ''}`}
        >
          {metric.children}
        </KpiCard>
      ))}
    </div>
  );
};

export default KpiCardGroup;
